import {openNotificationSuccess} from "@metronic/partials/notification";

export function copyToClipboard (text: string) {
    navigator.clipboard.writeText(text).then((response) => {
        openNotificationSuccess('Ссылка успешно скопирована')
    })
}